(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magen-category-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-magen-tabs]');
  sections.forEach((section) => {
    if (section.__magenTabsBound) return;
    section.__magenTabsBound = true;

    const triggers = Array.from(section.querySelectorAll('[data-magen-tab-trigger]'));
    const panels = section.querySelectorAll('[data-magen-tab-panel]');

    const activate = (trigger) => {
      const target = trigger.getAttribute('data-magen-tab-trigger');

      triggers.forEach((other) => {
        const isActive = other === trigger;
        other.classList.toggle('is-active', isActive);
        other.setAttribute('aria-selected', String(isActive));
        other.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-magen-tab-panel') === target;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    };

    triggers.forEach((trigger, idx) => {
      trigger.addEventListener('click', () => activate(trigger));

      // ARIA Tabs keyboard pattern: ←/→/Home/End move focus across triggers.
      trigger.addEventListener('keydown', (event) => {
        let next = null;
        switch (event.key) {
          case 'ArrowRight':
            next = triggers[(idx + 1) % triggers.length];
            break;
          case 'ArrowLeft':
            next = triggers[(idx - 1 + triggers.length) % triggers.length];
            break;
          case 'Home':
            next = triggers[0];
            break;
          case 'End':
            next = triggers[triggers.length - 1];
            break;
          default:
            return;
        }
        event.preventDefault();
        next.focus();
        activate(next);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
